import { getUserInfo } from "@/api/system";
import IsBlackModal from "@/components/isBlackModal.vue";
import { createApp } from 'vue';

// 白名单
const whiteList = [
  'pages/login/login', 
  // 'pages/scan/scan',
  // 'pages/oderding/oderding',
  // 'pages/index/caboderPage2',
];
// 黑名单
// const blackList = [
//   'pages/index/index',
//   'pages/selectCabinet/selectCabinet',
//   'pages/scheduledRoom/scheduledRoom',
//   'pages/preoder/preoder',
// ]
// 容器
const container = document.createElement('div');
container.id = 'black-global-modal';
let modalApp: any;

// 判断用户是否被店铺拉黑
const useIsBlack = async (page?: any) => {
  const { data } = await getUserInfo({});
  if (data.is_black) {
    if (!page) {
      page = window.location.hash;
    }
    if (page) {
      console.log(page);
      const index = whiteList.findIndex(item => page?.includes(item));
      if (index < 0) {
        const black = document.getElementById('black-global-modal');
        if (!black) {
          document.body.appendChild(container);
        }
        modalApp = createApp(IsBlackModal, {
          contact: data.contact,
        });
        modalApp.mount(container);
      } else {
        modalApp?.unmount();
      }
    }
  } else {
    modalApp?.unmount();
  }
}

export default useIsBlack;